import { render } from "./TdmView.vue?vue&type=template&id=0d7d65b6&ts=true"
import script from "./TdmView.vue?vue&type=script&lang=ts"
export * from "./TdmView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__